import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { ArrowLeft, Loader2, MailCheck, KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [done, setDone] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data);
      if (data.dev_token) setToken(data.dev_token);
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  const reset = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] px-6 py-14">
      <div className="w-full max-w-md animate-fade-up">
        <Logo size={34} tagline />
        <div className="clay mt-8 p-8">
          {done ? (
            <div className="text-center">
              <div className="mx-auto grid place-items-center h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-600">
                <MailCheck size={22} />
              </div>
              <h1 className="mt-5 font-display text-2xl font-semibold text-slate-900">Password diperbarui</h1>
              <p className="mt-2 text-sm text-slate-500">Silakan masuk dengan password baru Anda.</p>
              <Link to="/login">
                <Button className="mt-7 w-full h-11 rounded-xl grad-brand text-white" data-testid="back-to-login-button">Ke halaman masuk</Button>
              </Link>
            </div>
          ) : !sent ? (
            <>
              <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900">Lupa password</h1>
              <p className="mt-2 text-sm text-slate-500">Masukkan email terdaftar, kami kirimkan tautan reset.</p>
              <form onSubmit={request} className="mt-7 space-y-5" data-testid="forgot-password-form">
                <div className="space-y-2">
                  <Label htmlFor="fp-email" className="text-xs font-semibold text-slate-700">Email</Label>
                  <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="h-11 rounded-xl" placeholder="nama@instansi.go.id" data-testid="forgot-email-input" />
                </div>
                {err && <p className="text-sm text-red-600" data-testid="forgot-error">{err}</p>}
                <Button type="submit" disabled={busy} className="w-full h-11 rounded-xl grad-brand text-white" data-testid="forgot-submit-button">
                  {busy ? <Loader2 size={16} className="animate-spin" /> : "Kirim tautan reset"}
                </Button>
              </form>
            </>
          ) : (
            <>
              <div className="grid place-items-center h-12 w-12 rounded-2xl bg-brand-50 text-brand-600">
                <KeyRound size={22} />
              </div>
              <h1 className="mt-5 font-display text-2xl font-semibold text-slate-900">Setel password baru</h1>
              <p className="mt-2 text-sm text-slate-500">{sent.message} Token reset sudah terisi otomatis pada mode demo.</p>
              <form onSubmit={reset} className="mt-7 space-y-5" data-testid="reset-password-form">
                <div className="space-y-2">
                  <Label className="text-xs font-semibold text-slate-700">Token reset</Label>
                  <Input value={token} onChange={(e) => setToken(e.target.value)} required className="h-11 rounded-xl font-mono text-xs" data-testid="reset-token-input" />
                </div>
                <div className="space-y-2">
                  <Label className="text-xs font-semibold text-slate-700">Password baru</Label>
                  <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={6} className="h-11 rounded-xl" data-testid="reset-password-input" />
                </div>
                {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
                <Button type="submit" disabled={busy} className="w-full h-11 rounded-xl grad-brand text-white" data-testid="reset-submit-button">
                  {busy ? <Loader2 size={16} className="animate-spin" /> : "Simpan password"}
                </Button>
              </form>
            </>
          )}
        </div>
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-brand-600">
          <ArrowLeft size={15} /> Kembali ke masuk
        </Link>
      </div>
    </div>
  );
}
